// core
import React from 'react';
import { Link } from "react-router-dom";

// confs
import conf from 'conf/ajax';

export default function AuthorLink({author})
{
    if(!author) return <></>
    const fullname = author.fullname;
    const url = `${conf.route.user}`.replace(':id', author.id);
    if (author.id)
    {
        return (
            <Link key={author.id} className="author-link link-icon" to={url} title="View user actvity"><i className="fa-solid fa-user"></i> <span>{fullname}</span></Link>
        )
    }
    else
    {
        return (
            <span key={author.id} className="author-link"><i className="fa-solid fa-user"></i> {fullname}</span>
        )
    }
}

AuthorLink.defaultProps =
{
    author: {
        fullname: '',
        id: ''
    }
};
